import { IAudioItem } from 'types/audio'
import { IMediaItem } from 'types/media'

export const getTimelineItemVolume = (
  activeItem: IMediaItem | IAudioItem
): number => {
  if ('meta' in activeItem && 'volume' in activeItem.meta) {
    return activeItem.meta.volume ?? 0
  }

  if ('volume' in activeItem) {
    return activeItem.volume
  }

  return 0
}

export const getInitialVolume = (
  activeAudiosVolume: (number | undefined)[]
) => {
  const firstVolume = activeAudiosVolume[0]
  const allSame = activeAudiosVolume.every(volume => volume === firstVolume)

  // If all volumes are the same and it's a number, return it
  if (allSame && typeof firstVolume === 'number') {
    return firstVolume
  }

  return 100
}
